<div class="mainLayout-container w-full">
  <div class="app sm:scrool-smooth">
    <div class="board-container lg:flex sm:w-full md:w-full">
      <!-- NAVBAR -->
      <div class="sidenav-section hidden sm:hidden md:block lg:top-0">
        <nav
          class="lg:w-1/4 flex h-fit px-[5px] my-[10px] top-0 overflow-y-scroll">
          <app-nav-bar
            class="h-screen fixed top-0 transition-all duration-700 shadow-lg rounded-s-2xl"></app-nav-bar>
        </nav>
      </div>

      <div
        class="body-main-content w-full sm:ml-0 sm:w-full  md:w-[69rem] md:h-full md:ml-[14rem] h-svh">
        <div class="body-content">
          <div class="header-container md:h-1/5">
            <app-header></app-header>
          </div>
          <div class="content-container  md:h-3/5 ">
            <div class="hero-section bg-[#F0F1F2] rounded-[20px]">
              <div class="body-content p-3 ">
                <router-outlet></router-outlet>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
